import { render } from "./TagData.vue?vue&type=template&id=d7b677c0"
import script from "./TagData.vue?vue&type=script&lang=js"
export * from "./TagData.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__